
import React from 'react';
import { Checkbox } from '../ui/checkbox';
import { RecipeIngredient } from '@/services/recipes/types';
import { useTranslation } from 'react-i18next';

interface IngredientsListProps {
  ingredients: RecipeIngredient[];
  currentLang: string;
}

const IngredientsList: React.FC<IngredientsListProps> = ({ ingredients, currentLang }) => {
  const { t } = useTranslation();
  // Aseguramos que ingredients sea siempre un array
  const safeIngredients = Array.isArray(ingredients) ? ingredients : [];

  return (
    <div className="mb-6">
      <h3 className="font-medium text-base mb-2">{t('ingredients')}</h3>
      <ul className="text-sm text-gray-600 space-y-2">
        {safeIngredients.length > 0 ? (
          safeIngredients.map((item, index) => (
            <li key={index} className="flex items-start">
              <div className="mr-2 mt-1">
                <Checkbox checked id={`ingredient-${index}`} />
              </div>
              <label htmlFor={`ingredient-${index}`} className="text-sm">
                {item.quantity} {item.unit} {item.ingredient_name}
              </label>
            </li>
          ))
        ) : (
          <li className="text-gray-500">{t('noIngredientsRegistered')}</li>
        )}
      </ul>
    </div>
  );
};

export default IngredientsList;
